import { ReactComponent as AccountIcon } from "@icons/account.svg";
import { BottomNavButton } from "./BottomNavButton";
import { ReactComponent as ContactUsIcon } from "@icons/contact-us-outline.svg";
import { ReactComponent as FilledAccountIcon } from "@icons/account-filled.svg";
import { ReactComponent as FilledContactUsIcon } from "@icons/contact-us-filled.svg";
import { ReactComponent as FilledHealthHubIcon } from "@icons/wellbeing-filled.svg";
import { ReactComponent as FilledHomeIcon } from "@icons/home-filled.svg";
import { ReactComponent as FilledResourcesIcon } from "@icons/resources-filled.svg";
import { ReactComponent as HealthHubIcon } from "@icons/wellbeing.svg";
import { ReactComponent as HomeIcon } from "@icons/home.svg";
import { ReactComponent as ResourcesIcon } from "@icons/resources.svg";
import { t } from "i18next";
import { useLocation } from "react-router-dom";

export const BottomNavBar = () => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <nav role="navigation" className="bottom-nav-container">
      <div className="flex flex-row justify-evenly items-center h-full w-full text-sm">
        <BottomNavButton
          active={path.startsWith("/home")}
          navigatePath="/home"
          activeIcon={FilledHomeIcon}
          inactiveIcon={HomeIcon}
          ariaLabel={t("navigation.homeNavigationLabel")}
          buttonText={t("navigation.homeButton")}
        />
        <BottomNavButton
          active={path.startsWith("/health-hub")}
          navigatePath="/health-hub"
          activeIcon={FilledHealthHubIcon}
          inactiveIcon={HealthHubIcon}
          ariaLabel={t("navigation.healthHubNavigationLabel")}
          buttonText={t("navigation.healthHubButton")}
        />
        <BottomNavButton
          active={path.startsWith("/resources")}
          navigatePath="/resources"
          activeIcon={FilledResourcesIcon}
          inactiveIcon={ResourcesIcon}
          ariaLabel={t("navigation.resourcesNavigationLabel")}
          buttonText={t("navigation.resourcesButton")}
        />
        <BottomNavButton
          active={path.startsWith("/contact-us")}
          navigatePath="/contact-us"
          activeIcon={FilledContactUsIcon}
          inactiveIcon={ContactUsIcon}
          ariaLabel={t("navigation.contactUsNavigationLabel")}
          buttonText={t("navigation.contactUsButton")}
        />
        <BottomNavButton
          active={path.startsWith("/account")}
          navigatePath="/account"
          activeIcon={FilledAccountIcon}
          inactiveIcon={AccountIcon}
          ariaLabel={t("navigation.accountNavigationLabel")}
          buttonText={t("navigation.accountButton")}
        />
      </div>
    </nav>
  );
};
